// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__BODhQ","header":"Modal_header__Ge8z7","close":"Modal_close__ox5h1"};